import { render, staticRenderFns } from "./TrademarkObjectionToUsCaseDecision.vue?vue&type=template&id=64c0d27c&"
import script from "./TrademarkObjectionToUsCaseDecision.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsCaseDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports